import { PureComponent } from "react";
import PictureComponent from "components/core/picture/picture-component";
import TextPartComponent from "/components/core/one-pager/mobile-content/text-part/text-part-component";
import { getAssetPath } from "/services/assets-service";

import componentStyles from "./mobile-content-component.scss";

export default class MobileContentComponent extends PureComponent {
  getTextColor() {
    const { backgroundColor } = this.props.imageWithBackgroundPart;
    return backgroundColor === "transparent" || backgroundColor === "white" ? "black" : "white";
  }

  render() {
    const { textPart, signupForm, collaborationWith, imageWithBackgroundPart, isMobileOnly } = this.props;

    return (
      <div className="mobile-content-component">
        <div className="text-part-wrapper">
          <TextPartComponent
            {...textPart}
            signupForm={signupForm}
            collaborationWith={collaborationWith}
            customStyle={"mobile-clean-look"}
            color={"black"}
            isMobileCleanLook={true}
            isMobileOnly={isMobileOnly}
          />
        </div>

        <PictureComponent
          pictureClass={"image-part-wrapper"}
          src={getAssetPath(imageWithBackgroundPart.src)}
          alt={imageWithBackgroundPart.alt}
        />

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

MobileContentComponent.defaultProps = {
  collaborationWith: {}
};
